import AdminApi from '../../../services/api'
import SonOffApi from '../../../services/apiSonoff'
import swal from 'sweetalert2';
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const SonOffApiService = new SonOffApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            username: '',
            id: 0,
            title: '',
            events: [],
            filter: '',
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
            useProfilePictures: false,
            showImagePreview: false,
            imageToPreviewUserId: 0,
            imageToPreview: "",
        }
    },

    computed: {
        filteredEvents() {
            return this.events;
        }
    },
    methods: {
        load: load,
        clickSearch: clickSearch,
        openImage: openImage,
        formatDateAndTime: formatDateAndTime,
        openDoor: openDoor,
        keymonitor: keymonitor,
        parseAddInfo: parseAddInfo,
        listener(){
           this.load();
        },

    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.id = this.$route.query.id;
        this.title = this.$route.query.name;
        this.load()
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });
        this.$trainingBus.$on('refreshEntrance', this.listener);
    },
    beforeDestroy() {
        this.$trainingBus.$off('refreshEntrance', this.listener)
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
            }
        }
    }
}

function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
    // this.openDoor()
}



function load() {
    let _self = this
    var model = {
        companyInfoId: _self.id,
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
    }
    AdminApiService.getEventItems(model)
        .then((response) => {
            _self.events = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.pagination.page = 1;
        this.load();
    }
}

function formatDateAndTime(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}

function parseAddInfo(event){
    try{
        var title = '';
        let addInfo = JSON.parse(event.additionalInfo)
        for (const [key, value] of Object.entries(addInfo)) {
            title += key + ': ' + value + '\n'
        }
        return title;
    }catch (e){
        return '';
    }
}

function openDoor(){
    SonOffApiService.openDoor()
        .then((response) => {

        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Home/Event/AllEventItems.js